import React from 'react'
import {
  taskLookupQuery,
  // getUserListQuery,
  FsmGroupT,
} from 'ui-io/queries/tasks/task-user-list-query'
// ui-io/queries/tasks/task-user-list-query
import { FormGroup, MenuItem } from '@blueprintjs/core'
import { ItemPredicate, Suggest } from '@blueprintjs/select'
import { useQuery } from 'react-query'
import { InlineSpinnerIcon } from 'ui-components'
import { AssignmentTypeT } from 'ui-io/task-io'

type UserDetailsT = {
  user: string
  // fsmGroup?: FsmGroupT --- IGNORE ---
}

const UserInputGroup = ({
  setUserDetail,
  taskFSMId,
  assignmentType,
  allUserList,
}: {
  setUserDetail: (userDetails: UserDetailsT | null) => void
  taskFSMId?: string
  assignmentType?: AssignmentTypeT
  allUserList?: string[]
}) => {
  const SuggestUser = Suggest.ofType<string>()

  const taskLookupConnection = useQuery(
    taskFSMId
      ? taskLookupQuery({ taskFSMId: taskFSMId, fsmRevision: 1 })
      : { enabled: false },
  )
  // const taskRelations = taskLookupConnection.data?.fsm?.relations
  // const fsmGroup = taskRelations?.fsm_groups[0]
  // const fsmGroupId = fsmGroup?.fsm_group_id
  //Temporarily fetching userList for each workflow_configurations in frontend. To be removed later.
  // const userLookupConnection = useQuery(
  //   fsmGroupId && assignmentType !== undefined
  //     ? getUserListQuery({
  //         fsmId: fsmGroupId,
  //         fsmRevision: 1,
  //         assignmentType,
  //       })
  //     : { enabled: false },
  // )

  const userList = allUserList;

  const prepareUserDetails = (user: string) => {
    setUserDetail({ user })
  }

  const filterUser: ItemPredicate<string> = (
    query,
    item,
    _index,
    exactMatch,
  ) => {
    const normalizedTitle = item.toLowerCase()
    const normalizedQuery = query.toLowerCase()

    if (exactMatch) {
      return normalizedTitle === normalizedQuery
    } else {
      return item.indexOf(normalizedQuery) >= 0
    }
  }

  return (
    <FormGroup label="Select a user to assign :" inline>
      <SuggestUser
        itemPredicate={filterUser}
        fill
        items={!userList ? [] : userList}
        noResults={
          taskLookupConnection.isLoading  ? (
            <InlineSpinnerIcon />
          ) : (
            <MenuItem disabled={true} text="No results." />
          )
        }
        onItemSelect={(userid: string) => {
          prepareUserDetails(userid)
        }}
        itemRenderer={(item, itemProps) => (
          <MenuItem
            key={item}
            active={itemProps.modifiers.active}
            text={item}
            onClick={itemProps.handleClick}
          />
        )}
        inputValueRenderer={(userid) => userid}
        popoverProps={{ minimal: true }}
      />
    </FormGroup>
  )
}
export default UserInputGroup
